import companyApi from '../_api'
import { _sortOfficeConfiguration, _generateOfficeConfiguration } from '../_utils/utils'
export default {
  fetchCompany: async ({ dispatch, commit }, officeId) => {
    try {
      commit('setIsCallingCompany', true)
      const response = await companyApi.getOffice(officeId)
      const fuellFrozen = response.data.frozen
      commit('setCurrentCompany', response.data)
      commit('setIsFuellFrozen', fuellFrozen)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_fetch_company_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingCompany', false)
    }
  },
  updateCompany: async (
    { dispatch, commit },
    { officeId, updateInformation }
  ) => {
    try {
      const response = await companyApi.putOffice(officeId, updateInformation)
      commit('setCurrentCompany', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_update_company_error' },
        { root: true }
      )
      throw error
    }
  },
  /*  Dynamic validations */
  fetchOfficeFormConfigurations: async ({ commit, dispatch, getters }) => {
    if (getters.isCallingCompany) return
    try {
      commit('setIsCallingCompany', true)
      let { data } = await companyApi.getOfficeFormConfigurations()
      data = _sortOfficeConfiguration(data)

      commit('setOfficeFormConfigurations', _generateOfficeConfiguration(data))
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_fetch_office_form_config_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingCompany', false)
    }
  },
  updateOfficeFormConfiguration: async ({ commit, dispatch, getters }, { configId, officeForm }) => {
    if (getters.isCallingCompany) return
    try {
      commit('setIsCallingCompany', true)
      const { data } = await companyApi.putOfficeFormConfigurations(configId, officeForm)

      commit('updateOfficeFormConfiguration', data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_required_fields_modal_update_setting_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingCompany', false)
    }
  },
  clearCompany: ({ commit }) => {
    commit('setCurrentCompany', {})
  },

  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }

}
